import {
  CLEAR_MEASUREMENTS,
  FETCH_METRICS_BY_IDENTIFIER,
  CLEAR_METRICS
} from '#action/types';
import { fetchAdditions } from '#action/fetch';
import { getDateRange } from '#helper';

export function clearMeasurements() {
  return dispatch => {
    dispatch({
      type: CLEAR_MEASUREMENTS
    });
  };
}

export const fetchMetricsByIdentifier = ({ deviceId }, period, identifier) =>
  dispatch => {
    let metricsURI = `device/distinct/${deviceId}/measurements`;

    if (period) {
      const { start, end } = period;
      const range = getDateRange(start, end);
      metricsURI += `/${range.start}/${range.end}`;
    }

    metricsURI += `?metric=${identifier}`;

    return dispatch(fetchAdditions(
      metricsURI,
      FETCH_METRICS_BY_IDENTIFIER,
      { identifier }
    ));
  };

export const clearMetrics = () => dispatch => {
  dispatch({
    type: CLEAR_METRICS
  });
};
